import React, { MouseEvent } from 'react';
import { FieldArray, FormikValues, ArrayHelpers } from 'formik';
import { Button } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import checkPermission from '../../../utils/permissions/permissions';

interface IAddButtonProps {
  values: FormikValues;
  label: string;
  name: string;
  // eslint-disable-next-line
  rowCreator?: (name: string, values: any) => any;
  // eslint-disable-next-line
  style?: any
}

// eslint-disable-next-line
const defaultRowCreator = (name: string, values: any) => ({
  key: `${name}_${values[name].length}`,
  placeholder: true,
  name: '',
  apply: {
    active: false,
    facility: '',
    zone: '',
    uid: '',
  },
  properties: {},
});

const AddButton = ({
  values, label, name, rowCreator = defaultRowCreator, ...restProps
}: IAddButtonProps): JSX.Element => {
  const hasNotWritePermission = !checkPermission('rulesold', 'write');
  return (
    <FieldArray name={name}>
      {(arrayHelpers: ArrayHelpers) => (
        <Button
          disabled={hasNotWritePermission}
          type="link"
          block
          onClick={(event: MouseEvent<HTMLElement>) => {
            arrayHelpers.push(rowCreator(name, values));
            event.stopPropagation();
          }}
          // eslint-disable-next-line
        {...restProps}
        >
          {label}
          <PlusCircleOutlined style={{ fontSize: '20px' }} />
        </Button>
      )}
    </FieldArray>
  );
};

export default AddButton;
